import {
  getHealthTrends,
  type HealthTrendDataPoint,
  type HealthTrendType,
} from "@/services/core-api-adapter";
import { useQuery } from "@tanstack/react-query";

export const healthTrendsQueryKey = (healthTrendType: HealthTrendType) =>
  ["healthTrends", healthTrendType] as const;

export default function useHealthTrends(healthTrendType: HealthTrendType) {
  const { data, isPending, isLoading, isError, error, refetch } = useQuery({
    queryKey: healthTrendsQueryKey(healthTrendType),
    queryFn: async ({ signal }) => {
      const result = await getHealthTrends(healthTrendType, { signal });
      return result as HealthTrendDataPoint[];
    },
  });

  return {
    data: data ?? undefined,
    isLoading: isPending || isLoading,
    isError,
    error,
    refetch,
  };
}
